import ReportsMenu from "./ReportsMenu";
import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";

const NewlyAdmittedStudents = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [WingId, setWingId] = useState(0);
  const [SessionId, setSessioinId] = useState(
    localStorage.getItem("DefaultSession")
  );
  const [ClassId, setClassId] = useState(0);
  const [SectionID, setSectionID] = useState(0);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [OrderBy, setOrderBy] = useState("Student_Name");
  const [searchVersion, setSearchVersion] = useState(0);

  useEffect(() => {
    document.title = "Newly Admitted Students";
  }, []);

  useEffect(() => {
    if (!hasSearched || searchVersion === 0) {
      return;
    }

    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      SessionID: SessionId,
      Wing_Id: WingId,
      Class_Id: ClassId,
      Section_Id: SectionID,
      OrderBy: OrderBy,
      DateOfJoiningStart: StartDate,
      DateOfJoiningEnd: EndDate,
    };

    axios({
      method: "post",
      url: config.base_url + "Student/GetAdmittedStudents",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setLedger(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setLedger([]);
          setTotalRecords(0);
          if (response.data.status_message) {
            toast.info(response.data.status_message);
          }
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network error.");
      });
  }, [
    searchVersion,
    pageNo,
    pageSize,
    hasSearched,
    AccessKey,
    UserID,
    MemberType,
    SessionId,
    WingId,
    ClassId,
    SectionID,
    OrderBy,
    StartDate,
    EndDate,
  ]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!StartDate || !EndDate) {
      toast.error("Please select registration start date and end date.");
      return;
    }
    if (moment(EndDate).isBefore(moment(StartDate), "day")) {
      toast.error("End date cannot be before start date.");
      return;
    }
    setPageNo(1);
    setHasSearched(true);
    setSearchVersion((v) => v + 1);
  };

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item.Student_ID}</td>
            <td>{item.Registration_No}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Father_Name}</td>
            <td>
              {item.Date_Of_Joining
                ? moment(item.Date_Of_Joining).format("DD/MM/YYYY")
                : ""}
            </td>
            <td>{item.SelectedClass?.Class_Name}</td>
            <td>{item.SelectedSection?.Section_Name}</td>
          </tr>
        );
      });
    }
    return (
      <tr>
        <td colSpan="7">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            {hasSearched ? "No Data Found" : "Select dates and click Search"}
          </h4>
        </td>
      </tr>
    );
  };

  const printUrl =
    hasSearched && StartDate && EndDate
      ? `/Reports/PrintNewlyAdmittedStudents?SessionID=${SessionId}&Wing_Id=${WingId}&Class_Id=${ClassId}&Section_Id=${SectionID}&OrderBy=${OrderBy}&DateOfJoiningStart=${StartDate}&DateOfJoiningEnd=${EndDate}`
      : "#";

  return (
    <>
      <ReportsMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Reports/ReportsDashboard">Reports</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Newly Admitted Students
                  </li>
                </ol>
              </nav>
              <div className="page-title">Newly Admitted Students</div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card mb-2">
            <div className="card-body">
              <Form onSubmit={handleSearch}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Select Session:</label>
                      <select
                        className="form-select"
                        onChange={(e) => setSessioinId(e.target.value)}
                        name="SessionID"
                        value={SessionId}
                      >
                        <option value="0">---All---</option>
                        <SessionsDropDown />
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Select Wing:</label>
                      <select
                        name="Wing_Id"
                        value={WingId}
                        onChange={(e) => setWingId(e.target.value)}
                        className="form-select"
                      >
                        <option value="0">---All---</option>
                        <WingsDropDown />
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Select Class:</label>
                      <select
                        className="form-select"
                        onChange={(e) => setClassId(e.target.value)}
                        name="Class_ID"
                        value={ClassId}
                      >
                        <option value="0">---All---</option>
                        {SessionId != 0 && WingId != 0 && (
                          <ClassesDropDown
                            SessionID={SessionId}
                            WingID={WingId}
                          />
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Select Section:</label>
                      <select
                        className="form-select"
                        onChange={(e) => setSectionID(e.target.value)}
                        name="Section_Id"
                        value={SectionID}
                      >
                        <option value="0">---All---</option>
                        {ClassId !== 0 && (
                          <SectionDropDown ClassID={ClassId} />
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Registration Date From:</label>
                      <input
                        type="date"
                        className="form-control"
                        value={StartDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        max={moment().format(config.date_format_input)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Registration Date To:</label>
                      <input
                        type="date"
                        className="form-control"
                        value={EndDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        min={StartDate || undefined}
                        max={moment().format(config.date_format_input)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Order by:</label>
                      <select
                        name="OrderBy"
                        value={OrderBy}
                        onChange={(e) => setOrderBy(e.target.value)}
                        className="form-select"
                      >
                        <option value="Student_Name">Student Name</option>
                        <option value="Registration_No">Registration No</option>
                        <option value="Wing_Name">Wing Name</option>
                        <option value="Class_Name">Class</option>
                        <option value="Student_ID">Student ID Asc</option>
                        <option value="Student_ID desc">Student ID Desc</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-3 text-end">
                    <div className="form-group text-end">
                      <button
                        type="submit"
                        className="w-100 button button-primary mt-4"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <table className="table table-theme">
                <thead>
                  <tr>
                    <th colSpan={7}>{totalRecords} Total Records Found</th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th>Student ID</th>
                    <th>Registration No.</th>
                    <th>Student Name</th>
                    <th>Father Name</th>
                    <th>Date Of Joining</th>
                    <th>Class</th>
                    <th>Section</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td className="text-center" colSpan="7">
                        <Spinner animation="border" role="status"></Spinner>
                      </td>
                    </tr>
                  ) : (
                    renderLedger()
                  )}
                </tbody>
              </table>
              {totalRecords > pageSize && (
                <div className="pagination-wrap">
                  <div className="row align-items-center">
                    <div className="col-md-2 form_default">
                      <div className="d-flex align-items-center">
                        <label className="me-2" style={{ fontSize: "15px" }}>
                          Page Size
                        </label>
                        <div className="form-group">
                          <select
                            className="form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={(e) => {
                              setPageNo(1);
                              setPageSize(parseInt(e.target.value, 10));
                            }}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <Pagination
                      pageNo={pageNo}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="card mt-2 text-end">
            <div className="card-body">
              <a
                href={printUrl}
                target="_blank"
                rel="noreferrer"
                className={`button button-primary ${!hasSearched ? "disabled" : ""}`}
                onClick={(e) => {
                  if (!hasSearched) e.preventDefault();
                }}
              >
                Print Above List
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewlyAdmittedStudents;
